import { createSlice } from "@reduxjs/toolkit";

interface UiState {
  isSideMenuOpen: boolean;
  isProfileSheetOpen: boolean;
  sideMenuSelectedHash: string | null;
}

const initialState: UiState = {
  isSideMenuOpen: false,
  isProfileSheetOpen: false,
  sideMenuSelectedHash: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleSideMenu: (state) => {
      state.isSideMenuOpen = !state.isSideMenuOpen;
    },
    setSideMenu: (state, { payload }) => {
      state.isSideMenuOpen = payload;
    },
    setProfileSheetOpen: (state, action) => {
      state.isProfileSheetOpen = action.payload;
    },
    setSideMenuSelectedHash: (state, action) => {
      state.sideMenuSelectedHash = action.payload;
    },
  },
});

export const {
  toggleSideMenu,
  setProfileSheetOpen,
  setSideMenu,
  setSideMenuSelectedHash,
} = uiSlice.actions;
export default uiSlice.reducer;
